import { Axis, AxisMapped, ReportSheet } from "interfaces/report";
import { Pie } from "react-chartjs-2";
import { getTextColor } from "utils/string";
import numeral from "numeral";

interface Props {
  sheet: ReportSheet<AxisMapped>;
}

export const PieChart = ({ sheet }: Props) => {
  const colors: string[] = sheet.xAxis
    .filter((item) => !item.hide)
    .filter((item) => item.active)
    .map((item) => item.color);

  const mappingData = () => {
    const yAxis = sheet.yAxis.find(
      (ele) => ele.active && !ele.hide
    ) as AxisMapped;

    const data = sheet.data
      .find((items) => {
        return items[0] === (yAxis?.value || 0);
      })
      ?.slice(1) as any[];

    return data;
  };

  const data = {
    labels: sheet.xAxis.map((item) => item.value),
    datasets: [
      {
        data: mappingData(),
        backgroundColor: colors,
        borderColor: colors,
        borderWidth: 1,
      },
    ],
  };

  return (
    <Pie
      options={{
        plugins: {
          tooltip: {
            callbacks: {
              label(tooltipItem) {
                const value = tooltipItem.parsed;
                const formatted = value.toLocaleString("en-AU", {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 2
                });

                return `${tooltipItem.label}: ${formatted}`;
              },
            },
          },
          datalabels: {
            formatter: (value, ctx: any) => {
              const total = ctx.chart.$totalizer.totals[ctx.datasetIndex];
              const percent =  value / total;
              return numeral(percent).format('0.00%');
            },
            display: function (ctx: any) {
              const total = ctx.chart.$totalizer.totals[ctx.datasetIndex];
              const value = ctx.dataset.data[ctx.dataIndex];

              return value / total > 0.02;

              // const value = ctx.dataset.data[ctx.dataIndex];
              // return !!value;
            },
            color: (context) => {
              return getTextColor(
                (
                  context.chart.data.datasets[context.datasetIndex]
                    .backgroundColor as any
                )[context.dataIndex]
              );
            },
          },
          legend: {
            display: false,
          },
        },
      }}
      data={data}
    />
  );
};
